import ExportBase from "../exportbase";



class ExportDAIA extends ExportBase
{


constructor(props)
{
    super(props);

    this.state.formulaire =
    {
    }
        

    this.onAssetDownloaded = this.onAssetDownloaded.bind(this)
    this.handleOnChange = this.handleOnChange.bind(this)


    this.ready = false;
    this.lastFormulaireSend = "";

}

componentDidMount()
{
    super.componentDidMount();
    console.log("export daia did mount")
    
    
}

componentDidUpdate()
{
    super.componentDidUpdate()
    
}

createWorker()
{
    console.log("daia create woker")
    return new Worker(new URL('./DAIAworker.js', import.meta.url));
}

sendFormulaire()
{
    var datas = {};

    

    datas.formulaire  = {};

    if (this.lastFormulaireSend !== JSON.stringify(datas))
    {
        console.log("daia send formulaire", datas)
        this.lastFormulaireSend = JSON.stringify(datas);
            this.startComputeFile(datas)
    }

    
    
}


handleOnChange()
{
    if (this.ready) this.sendFormulaire();
};

onAssetDownloaded(asset)
{

    var formulaire = this.state.formulaire;
    this.setState({formulaire: formulaire})
    this.ready = true;

    setTimeout(() => {
        this.sendFormulaire();
    }, 100);
    

    
    

}

render()

{
    // <>{this.props.format}<br/>{this.props.type}<br/>{this.props.title}<br/>{this.props.asid}</>

    return super.render(

    <>
        
    </>
        
    )
}
}

export default ExportDAIA;